class JobList {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.innerWidth >= 768) {
      $(".js-tab-area").each(function() {
        var $tabArea = $(this);
        $tabArea.find(".js-tab-content").hide();
        $tabArea.find(".js-job-tab:first").addClass("is-active");
        $tabArea.find(".js-tab-content:first").show();
      
        $tabArea.find(".js-job-tab").click(function() {
          $tabArea.find(".js-tab-content").hide();
          var index = $(this).index();
          $tabArea.find(".js-tab-content").eq(index).show();
      
          $tabArea.find(".js-job-tab").removeClass("is-active");
          $(this).addClass("is-active");
        });
      });
      
    } else {
      $('.js-acc-trigger').on('click', function() {
        $(this).next('.js-acc-wrap').slideToggle();
        $(this).find('.js-acc-plus').toggleClass('is-active');
      });
    }
  }
}
